import type { Paths } from '@zg-rentals/paths-manifest';

const getBaseToursUrl = (listingAlias: string, paths: Paths) => {
  return `${paths.propertiesPage}/${listingAlias}/tours`;
};

export const getFullCalendarPageUrl = (listingAlias: string, paths: Paths) => {
  return `${getBaseToursUrl(listingAlias, paths)}/tour-calendar`;
};

export const getTourAvailabilityPageUrl = (listingAlias: string, paths: Paths) => {
  return `${getBaseToursUrl(listingAlias, paths)}/tour-availability`;
};
